import { render, staticRenderFns } from "./RegrasAba.vue?vue&type=template&id=6a40f6e8&scoped=true"
import script from "./RegrasAba.vue?vue&type=script&lang=js"
export * from "./RegrasAba.vue?vue&type=script&lang=js"
import style0 from "./RegrasAba.vue?vue&type=style&index=0&id=6a40f6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40f6e8",
  null
  
)

export default component.exports